import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIImportPreferenceService } from '../../_services/import-preference/API-import-preference';
import { APIHeaderService } from '../../_services/header/API-header';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/table';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/filter';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
const today = new Date();
var time_today = today.getTime();
let now = new Date();
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');

@Component({
  selector: 'app-header-bulk-details',
  templateUrl: './header-bulk-details.component.html',
  styleUrls: ['./header-bulk-details.component.css']
})
export class HeaderBulkDetailsComponent implements OnInit {
  public BatchId: any;
  public ncprDetails: any; 
  dataSubject = new BehaviorSubject<any[]>([]);

  displayedColumns: string[] = [ 'urn', 'cli', 'htyp', 'ctgr', 'tmid','NatureOfBusiness','Comments','Email','mobileNumber','IndustryType', 'sts','FailureReason'];

  fetchedData:any;
  form1: any = {};
onSubmitFilter(filterForm){
  console.log(filterForm.value);
  console.log("hi !!!");
  const fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
  const ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530'); 
  const param = filterForm.search;

  console.log("fdate",fdate);
  console.log("ldate",ldate,"param",param);

  const filterType = filterForm.searchBy;

   let data = {
	
    "Start_Date": fdate,
    "End_Date":ldate,
    "ServiceAreaCode":param,
    "Status":param,
    "PhoneType" :param,
    "filterType":filterType
    }
    console.log("after");
    console.log("data"+data);
    console.log("jsonData"+JSON.stringify(data));


}
onChangeDataSource(value)
{
  this.dataSubject.next(value);
  this.dataSource = new MatTableDataSource();
  
  this.dataSource = new MatTableDataSource(value);
  this.dataSource.paginator = this.paginator;
  console.log("dataSource : ", this.dataSource);
}


  applyFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  headerFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  statusFilter(filterValue: string) {
    console.log("in filter");
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  GetDND_COMPLAINTS_TSP: any;

  dataSource: any;
  public reqId: any;
  public ncprFilename: any;
  public reqDate: any;
  public uploadedBy: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private imp: APIImportPreferenceService,
	private head: APIHeaderService,
    private _route: ActivatedRoute,
    private db: $DBManagerService,
    private router: Router,

  ) {
    this._route.params.subscribe((params) => {
      this.BatchId = params['BatchId'];
      this.ncprFilename = params['FileName'];
      this.getHeaderBulkDetails(this.BatchId);
    })

    this.head.getHeaderBulkDetails(this.BatchId).subscribe({
      next: value => {
        this.dataSubject.next(value); 
        this.dataSource = new MatTableDataSource(value);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log("dataSource : ", this.dataSource);

      }
    })


}
ngOnInit() {
  if(this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN) ==null && this.db.get(Constants.SESSSION_STORAGE, Constants.Entity_EmailID)== null)
  {
    this.router.navigate(['/']);
  }

}

getHeaderBulkDetails(BatchId){
 this.head.getHeaderBulkDetails(BatchId)
    .subscribe(t => { 
      this.ncprDetails = t;
      console.log("headersummaryncpr :::: ", JSON.stringify(this.ncprDetails));
    });
}

reset(){
  console.log("inside reset");
  this.getHeaderBulkDetails(this.BatchId);
  this.afterReset();

}

afterReset(){
  this.head.getHeaderBulkDetails(this.BatchId).subscribe({
    next: value => {
      this.dataSubject.next(value);
      this.dataSource = new MatTableDataSource(value);
      this.dataSource.paginator = this.paginator;
      console.log("dataSource : ", this.dataSource);

    } 
  })

}
}
export class MyDataSource extends DataSource<any[]> {

  constructor(private subject: BehaviorSubject<any[]>) {
    super();
  }
  connect(): Observable<any[]> {
    return this.subject.asObservable();
  }
  disconnect(): void {

  }



}
